// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-modal {
  width: var(--info-modal-width-desktop) !important;
}
@media (max-width: 992px) {
  .info-modal {
    width: var(--info-modal-width-tablet) !important;
  }
}
@media (max-width: 768px) {
  .info-modal {
    width: var(--info-modal-width-mobile) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/modals/InfoModal/InfoModal.scss"],"names":[],"mappings":"AAAA;EACI,iDAAA;AACJ;AAAI;EAFJ;IAGQ,gDAAA;EAGN;AACF;AAFI;EALJ;IAMQ,gDAAA;EAKN;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
